import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface ChargePointListIsOnlineHeaderProps
  extends HeaderContext<
    GatewayChargePointModel,
    GatewayChargePointModel['isOnline']
  > {}

export const ChargePointListIsOnlineHeader =
  () // props: ChargePointListIsOnlineHeaderProps,
  : ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    // Nothing to do

    // RENDER ////////////////////////////////////////////////////////////////////

    return <Icon name="wifi" />;
  };
